// export const BaseIP="http://192.168.29.114:8090/"  // local



export const BaseIP="https://metrogroupsmg.com/"


